import React, { useState, useEffect, useRef } from "react";
import "./Server.css";
import { useNavigate } from "react-router-dom";
import { vandalServer } from "../../utils/ServerApi";

import Arrow from "../../images/serverArrow.svg";
import Del from "../../images/serverDel.svg";
import Download from "../../images/serverDownload.svg";
import Edit from "../../images/serverEdit.svg";
import FilePlus from "../../images/serverFilePlus.svg";
import FolderPlus from "../../images/serverFolderPlus.svg";
import Load from "../../images/serverLoad.svg";
import Folder from "../../images/serverFolder.svg";
import File from "../../images/serverFile.svg";


import ServerPopup from "../ServerPopup/ServerPopup";

function Server(props) {
  const [files, setFiles] = useState([]);
  const [path, setPath] = useState("/");
  const [inputPath, setInputPath] = useState("/");

  const [openServerPopup, setIsOpenServerPopup] = useState(false);
  const [typeFile, setTypeFile] = useState("");

  React.useEffect(() => {
    getFiles("folder", path);
  }, []);

  function getFiles(folder, path) {
    vandalServer.getFiles(folder, path).then((data) => {
      setFiles(data.files);
      console.log(files);
    });
  }

  function handleInputChange(event) {
    setInputPath(event.target.value);
  }

  function handleInputSubmit() {
    setPath(inputPath || "/");
    getFiles("folder", inputPath || "/");
  }

  function goBack() {
    const segments = path.split("/").filter((seg) => seg); // Разделяем путь на сегменты
    segments.pop(); // Удаляем последний сегмент
    const newPath = "/" + segments.join("/"); // Формируем новый путь
    setPath(newPath || "/"); // Обновляем путь
    setInputPath(newPath || "/");
    getFiles("folder", newPath || "/");
  }

  // Навигация в папку
  function openFolder(folderName, type) {
    const newPath = path.endsWith("/")
      ? `${path}${folderName}`
      : `${path}/${folderName}`;
    setInputPath(newPath);
    setPath(newPath); // Обновляем путь
    getFiles(type, newPath); // Загружаем содержимое папки
  }

  function deleteFolder(folderName, type) {
    const newPath = path.endsWith("/")
      ? `${path}${folderName}`
      : `${path}/${folderName}`;
    vandalServer.deleteFile(type, newPath).then((data) => {
      if (data) {
        getFiles("folder", inputPath);
      }
      console.log(data);
    });
  }

  function createFolder(folderName, type, path) {
    vandalServer.createFile(folderName, type, path).then((data) => {
      if (data) {
        getFiles("folder", inputPath);
        setIsOpenServerPopup(false);
      }
      console.log(data);
    });
  }

  return (
    <div className="server">
      <div className="server__header">
        <button className="server__header__arrow" onClick={goBack}>
          <img alt="icon" src={Arrow} className="server__header__arrow__btn" />
        </button>
        <input
          className="server__header__input"
          type="text"
          placeholder="Введите адрес"
          value={inputPath}
          onChange={handleInputChange}
          onKeyDown={(e) => e.key === "Enter" && handleInputSubmit()}
        />
        <button className="server__header__btn">
          <img alt="icon" src={Load} className="server__header__arrow__btn" />
        </button>
        <button onClick={() => {
          setTypeFile("folder")
          setIsOpenServerPopup(true)
        }} className="server__header__btn">
          <img
            alt="icon"
            src={FolderPlus}
            className="server__header__arrow__btn"
          />
        </button>
        <button onClick={() => {
          setTypeFile("file")
          setIsOpenServerPopup(true)
        }} className="server__header__btn">
          <img
            alt="icon"
            src={FilePlus}
            className="server__header__arrow__btn"
          />
        </button>
      </div>
      <div className="server__body">
        {Array.isArray(files) &&
          files.map((i) => (
            <div className="server__body__card" key={i.name || i.id}>
              <button
                onClick={() => {
                  openFolder(i.name, i.type);
                }}
                className="server__body__card__header"
              >
                <img
                  alt="icon"
                  className="server__body__card__header__img"
                  src={i.type === "file" ? File : Folder}
                />
                <p className="server__body__card__header__title">{i.name}</p>
              </button>
              <button className="server__header__btn">
                <img
                  alt="icon"
                  src={Edit}
                  className="server__header__arrow__btn"
                />
              </button>
              <button className="server__header__btn">
                <img
                  alt="icon"
                  src={Download}
                  className="server__header__arrow__btn"
                />
              </button>
              <button
                onClick={() => {
                  deleteFolder(i.name, i.type);
                }}
                className="server__header__btn"
              >
                <img
                  alt="icon"
                  src={Del}
                  className="server__header__arrow__btn"
                />
              </button>
            </div>
          ))}
      </div>
      {openServerPopup && <ServerPopup setIsOpenServerPopup={setIsOpenServerPopup} createFolder={createFolder} typeFile={typeFile} pathFile={inputPath}/>}
    </div>
  );
}

export default Server;
